export const PAGE_SIZE = 8;

export const NO_THEME_TEMPLATES_MESSAGE_TITLE = 'No Theme Templates Found';
export const NO_THEME_TEMPLATES_MESSAGE_CONTENT =
  'There are currently no theme templates available for this recipe. Please create a new theme template to get started.';

export const LOADING_TEMPLATES_MESSAGE_TITLE = 'Loading Theme Templates';
export const LOADING_TEMPLATES_MESSAGE_CONTENT = 'Please wait while we load the theme templates.';
